/**
 * Colores canónicos del pack de animaciones (Bodymovin, rango 0–1).
 * Se sustituyen por los definidos en --pwcs-lottie-frame-* vía DesignService.
 */
export const LOTTIE_TEMPLATE_BRAND_PURPLE: [number, number, number] = [
	0.180392156863, 0.047058827269, 0.301960784314,
];

/** Gris de iconos / textos decorativos en animaciones OCR. */
export const LOTTIE_TEMPLATE_ICON_GRAY: [number, number, number] = [
	0.388235294118, 0.380392156863, 0.407843137255,
];

/** Fondo tarjeta claro (tutorial prueba de vida light). */
export const LOTTIE_TEMPLATE_PRUEBA_VIDA_LIGHT_BG: [number, number, number] = [
	0.956862745098, 0.941176470588, 0.988235294118,
];

/** Fondo tarjeta oscuro (tutorial prueba de vida dark). */
export const LOTTIE_TEMPLATE_PRUEBA_VIDA_DARK_BG: [number, number, number] = [
	0.839215686275, 0.854901960784, 1,
];

/**
 * Puntos del óvalo (`upper-line` / `low-line`) en prueba de vida light.
 * Hex #4B36AD — se sustituye por borde secundario (NIF-751).
 */
export const LOTTIE_TEMPLATE_OVAL_DOTS: [number, number, number] = [
	0.294117647059, 0.211764705882, 0.678431372549,
];

export const LOTTIE_COLOR_MATCH_EPSILON = 0.02;
